import axiosInstance from 'utils/axiosInstance';

const sendContactForm = (data) => {
  return axiosInstance
    .post('/contact_form.php', { ...data })
    .then(({ response }) => {
      return response;
    })
    .catch(({ message }) => {
      return message;
    });
};

const contactFromService = {
  sendContactForm,
};

export default contactFromService;
